import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './Chat.module.sass';
import supportAvatar from '../../img/support.png';
import { logAudit } from '../../utils/audit';
import {
    Headset, SendHorizontal, MessagesSquare, Percent, ShieldCheck,
    ReceiptText, ArrowLeftRight, UserRound, Eraser, ChevronRight,
} from 'lucide-react';

// Import icons for chat presets
import commissionModalIcon from '../../img/iconsas/comission_modal.png';
import verificationModalIcon from '../../img/iconsas/verification_modal.png';
import nameUserChatIcon from '../../img/iconsas/name_user_and_chat_preset.png';
import taxModalIcon from '../../img/iconsas/tax_modal.png';

const initialMessages = [];

const presets = [
    [
        { author: 'Support', text: 'Selamat datang! Nama saya <SUPPORT NAME>, dan saya di sini untuk membantu anda. Bagaimana saya boleh membantu anda hari ini?' },
        { author: 'You', text: 'Selamat sejahtera. Saya perlu bertanya tentang pelanggan saya <CLIENT NAME>. Kami sedang cuba memproses pemindahan sebanyak <MONEY> ke akaun mereka <CBU/CVU> di <BANK>. Pembayaran pengesahan telah diminta. Bolehkah anda menjelaskan rasional di sebalik keperluan ini?' },
        { author: 'Support', text: 'Saya mohon maaf atas sebarang kesulitan. Biar saya semak perkara ini untuk anda dan mengesahkan butiran pertanyaan anda.' },
        { author: 'Support', text: 'Saya telah menyemak permintaan pengeluaran yang dikemukakan atas nama <CLIENT NAME> untuk jumlah <MONEY>. Keperluan pembayaran pengesahan telah dilaksanakan sebagai langkah perlindungan untuk melindungi aset pelanggan anda. Setelah pengesahan berjaya dan pengesahan bahawa maklumat penerima sepadan dengan butiran pengirim, kami akan meneruskan pemindahan dana ke alamat yang ditetapkan. Prosedur ini merupakan komponen penting dalam rangka kerja keselamatan komprehensif kami, yang direka untuk mencegah transaksi tanpa kebenaran dan aktiviti penipuan oleh perantara yang mungkin cuba mengalihkan dana pelanggan ke akaun tanpa kebenaran. Kami menghargai pemahaman dan kerjasama anda dengan protokol keselamatan yang diperlukan ini.\n\nSila ambil perhatian bahawa setelah selesai proses pengesahan, jumlah <VERIF SUM> akan dikembalikan secara automatik bersama dengan pengeluaran dana anda.' },
        { author: 'You', text: 'Terima kasih atas penjelasan terperinci. Saya akan menyampaikan maklumat ini kepada pelanggan saya.' },
        { author: 'Support', text: 'Sama-sama! Jika anda memerlukan bantuan lanjut, jangan segan untuk menghubungi kami bila-bila masa. Semoga hari anda menyenangkan!'},
    ],
    [
        { author: 'Support', text: 'Selamat pagi! Saya <SUPPORT NAME> dari jabatan perkhidmatan pelanggan kami. Apa yang boleh saya bantu anda hari ini?' },
        { author: 'You', text: 'Selamat pagi. Pelanggan saya <USER NAME> baru-baru ini telah menyelesaikan proses pembayaran pengesahan. Walau bagaimanapun, kami masih tidak dapat meneruskan pengeluaran pendapatan. Bolehkah anda menerangkan apa yang menghalang transaksi ini?' },
        { author: 'Support', text: 'Saya mohon maaf atas kesulitan ini. Kami telah melaksanakan dasar pengeluaran baharu mulai <YESTERDAY DATE>. Semua pengeluaran kini mempunyai yuran pemprosesan standard untuk operasi antara bursa Jepun dan AS. Butiran penuh telah dihantar melalui saluran pemberitahuan anda.' },
        { author: 'You', text: 'Saya menghargai penjelasan itu. Walau bagaimanapun, saya ingin mencadangkan untuk memberi notis awal kepada broker tentang perubahan dasar seperti ini. Ia meletakkan saya dalam kedudukan sukar dengan pelanggan saya apabila saya tidak dimaklumkan terlebih dahulu.' },
        { author: 'Support', text: 'Saya memahami kebimbangan anda dan mohon maaf atas kesulitan ini. Setelah yuran komisen dibayar, <WITHDRAWAL AMOUNT> akan dipindahkan ke akaun <ACCOUNT NUMBER> di <BANK> atas nama <CLIENT NAME>. Terima kasih atas pemahaman anda.' },
        { author: 'Support', text: 'Adakah ada perkara lain yang boleh saya bantu anda hari ini?' },
    ],
    [
        { author: 'Support', text: 'Selamat datang! Saya <SUPPORT NAME>, pakar pematuhan kanan. Bagaimana saya boleh membantu anda hari ini?' },
        { author: 'You', text: 'Selamat sejahtera. Saya memerlukan penjelasan mengenai taksiran cukai IRS yang dikenakan ke atas pelanggan saya. Pelanggan yang dimaksudkan ialah <CLIENT NAME>, dan kami sedang cuba memproses pemindahan <WITHDRAWAL AMOUNT> ke akaun mereka <CBU/CVU> di <BANK>. Bolehkah anda memberikan penjelasan terperinci tentang asas peraturan untuk keperluan cukai ini?' },
        { author: 'Support', text: 'Sudah tentu. Biar saya buka akaun <CLIENT NAME> dan semak sejarah transaksi.' },
        { author: 'Support', text: 'Setelah semakan, saya boleh mengesahkan bahawa permintaan pemindahan untuk <WITHDRAWAL AMOUNT> kini digantung sehingga selesai kewajipan cukai mandatori.\n' +
                '\n' +
                'Sila ambil maklum bahawa berkuat kuasa dari permulaan tahun fiskal ini, platform kami dikehendaki mengekalkan pematuhan ketat dengan piawaian cukai antarabangsa yang dipertingkatkan, terutamanya untuk transaksi kewangan merentas sempadan.\n' +
                '\n' +
                'Dalam kes khusus ini, pelanggan anda, sebagai penduduk Malaysia, telah menjana keuntungan melalui platform kendalian Jepun kami. Memandangkan sebahagian daripada transaksi ini diproses melalui rangka kerja peraturan Amerika Syarikat—terutamanya apabila melibatkan aset digital USDT dan BNB—transaksi tersebut berada di bawah bidang kuasa protokol cukai Perkhidmatan Hasil Dalam Negeri (IRS).\n' +
                '\n' +
                'Walaupun anda berkhidmat sebagai broker yang dibenarkan dan telah memudahkan transaksi ini, liabiliti undang-undang untuk kewajipan cukai terletak pada benefisiari akhir, iaitu <CLIENT NAME>. Prinsip ini ditetapkan di bawah peraturan pematuhan kewangan antarabangsa, yang mengamanahkan tanggungjawab cukai kepada individu yang menerima faedah monetari.\n' +
                '\n' +
                'Sila fahami bahawa tanpa memenuhi kewajipan cukai ini, transaksi kekal tertakluk kepada penahanan automatik yang dikenakan oleh pihak berkuasa kawal selia antarabangsa. Ini bukan langkah budi bicara oleh platform kami, tetapi komponen mandatori rangka kerja anti-pengubahan wang haram (AML) global yang tidak boleh dielakkan.\n' +
                '\n' +
                'Untuk pelanggan anda <CLIENT NAME>, kadar cukai yang dikenakan ialah <TAX_PERCENT> daripada jumlah pengeluaran <WITHDRAWAL AMOUNT>, menghasilkan pembayaran cukai yang diperlukan sebanyak <TAX_AMOUNT>.\n' +
                '\n' +
                'Setelah pengesahan selesai pembayaran cukai, dana akan dibebaskan dan pemindahan akan diproses dalam masa satu jam.' },
        { author: 'You', text: 'Saya terpaksa bertanya - mengapa cukai ini tidak diperlukan sebelum ini? Ini adalah pelanggan kedua saya yang terpaksa membayar ini. Apa yang berubah dengan peraturan?' },
        { author: 'Support', text: 'Sebelum ini, keperluan cukai ini tidak dikuatkuasakan secara automatik. Walau bagaimanapun, berkuat kuasa Januari tahun ini, perjanjian pelbagai hala yang komprehensif telah diwujudkan antara Jepun, Amerika Syarikat, dan beberapa negara Asia Tenggara, termasuk Malaysia, sebagai sebahagian daripada inisiatif yang diselaraskan untuk mencegah pengelakan cukai mata wang kripto.\n' +
                '\n' +
                'Di bawah rangka kerja kawal selia semasa, apabila mana-mana transaksi melibatkan dana yang mengalir melalui bidang kuasa ini melalui platform antarabangsa, mekanisme pematuhan automatik dicetuskan yang menahan transaksi sehingga selesai pembayaran cukai. Ini terpakai khusus kepada kes di mana keuntungan melebihi ambang yang telah ditetapkan atau melibatkan transaksi merentas sempadan antara negara-negara yang mengambil bahagian ini.\n' +
                '\n' +
                'Walaupun protokol sebelumnya membenarkan semakan budi bicara berdasarkan kes demi kes, peraturan semasa mengamanahkan pematuhan ketat tanpa pengecualian. Platform kami telah dikehendaki melaksanakan pengubahsuaian sistem yang komprehensif untuk memastikan pematuhan penuh kepada piawaian kawal selia yang dipertingkatkan ini.' },
        { author: 'Support', text: 'Bolehkah saya membantu anda dengan apa-apa lagi mengenai perkara ini?' },
        { author: 'You', text: 'Terima kasih atas penjelasan menyeluruh. Saya akan menghubungi jika saya mempunyai sebarang soalan lain tentang perkara ini.' },
        { author: 'Support', text: 'Terima kasih kerana menghubungi, dan terima kasih atas kerjasama berterusan anda. Semoga hari anda produktif!' },
    ],
    [
        { author: 'You', text: 'Selamat sejahtera. Pelanggan saya <CLIENT NAME> baru-baru ini telah menyelesaikan proses pembayaran pengesahan dan berjaya mengesahkan kelayakan akaun mereka. Walau bagaimanapun, apabila cuba memproses pengeluaran, pemindahan telah disekat oleh sistem anda. Bolehkah anda menjelaskan sebab khusus untuk penggantungan transaksi ini?' },
        { author: 'Support', text: 'Terima kasih kerana menghubungi pasukan pematuhan kami. Saya faham perkara ini perlu diselesaikan dengan segera. Beri saya sebentar untuk memeriksa akaun pelanggan anda dan sejarah transaksi.' },
        { author: 'Support', text: 'Terima kasih atas kesabaran anda. Setelah semakan menyeluruh, saya boleh mengesahkan bahawa permintaan pengeluaran adalah untuk <WITHDRAWAL AMOUNT> ke <BANK> bertarikh <TODAY DATE>. Pemindahan telah digantung sementara disebabkan oleh prosedur pengesahan tambahan yang dimulakan mengikut keperluan Bank Negara Malaysia (BNM) di bawah Akta No. 25.246 mengenai pencegahan anti-pengubahan wang haram (AML). Di bawah peruntukan kawal selia ini, institusi kewangan dan sistem pembayaran diwajibkan menjalankan pengesahan terpilih transaksi antarabangsa, terutamanya yang melebihi ambang monetari tertentu atau menunjukkan profil transaksi bukan standard. Dalam kes pelanggan anda, proses pengesahan telah dicetuskan secara automatik, mengakibatkan penggantungan sementara.' },
        { author: 'You', text: 'Saya tahu pelanggan lain telah berjaya mengeluarkan ke bank yang sama. Mengapa transaksi pelanggan saya dilayan secara berbeza dan tertakluk kepada semakan tambahan?' },
        { author: 'Support', text: 'Saya memahami sepenuhnya kebimbangan anda, dan ini memang pertanyaan yang sah. Anda betul bahawa transaksi lain ke <BANK> telah diproses dengan jayanya, kerana prosedur pengesahan AML tidak digunakan secara universal tetapi berdasarkan asas terpilih. Kriteria pemilihan bergantung pada pelbagai faktor termasuk jumlah transaksi, kekerapan transaksi, dan parameter lain yang ditentukan oleh sistem perbankan atau algoritma BNM. Dalam kes khusus pelanggan anda, transaksi telah dipilih secara automatik untuk pengesahan yang dipertingkatkan, yang malangnya mengakibatkan kelewatan ini. Sila yakin bahawa ini tidak berkaitan dengan sebarang kesilapan di pihak pelanggan anda atau operasi platform kami; ia adalah keperluan prosedur standard yang direka untuk memastikan keselamatan dan pematuhan dengan piawaian kawal selia BNM.' },
        { author: 'You', text: 'Memandangkan situasi ini, apakah alternatif yang boleh anda tawarkan untuk menyelesaikan perkara ini?' },
        { author: 'Support', text: 'Objektif utama kami adalah untuk memastikan pelanggan anda menerima dana mereka secepat mungkin, dan kami mempunyai beberapa penyelesaian alternatif yang tersedia. Pilihan yang paling cekap adalah memproses pengeluaran dalam dolar Malaysia melalui sistem kad UnionPay. Transaksi ini diproses melalui rangkaian pembayaran antarabangsa, yang mengelakkan keperluan pengesahan AML tempatan dan membolehkan penyelesaian transaksi dalam masa 30 minit tanpa yuran tambahan atau prosedur pengesahan. Untuk meneruskan dengan pilihan ini, pelanggan anda perlu memberikan ID Pemuatan kad UnionPay mereka.' },
        { author: 'You', text: 'Berapakah jumlah RM yang tepat yang akan diterima oleh pelanggan saya dengan pilihan ini?' },
        { author: 'Support', text: 'Pengeluaran RM akan menjadi <USD AMOUNT> ringgit. Jika anda boleh memberikan butiran pengeluaran, saya boleh memproses permintaan ini segera.' },
    ],
];

const maleNames = [
    'Juan', 'Carlos', 'Miguel', 'Diego', 'Pablo', 'Luis', 'Javier', 'Alejandro', 'José', 'Manuel',
    'Santiago', 'Matías', 'Nicolás', 'Gabriel', 'Lucas', 'Martín', 'Facundo', 'Tomás', 'Sebastián', 'Ignacio',
    'Rodrigo', 'Daniel', 'Andrés', 'Federico', 'Emiliano', 'Agustín', 'Benjamín', 'Felipe', 'Lautaro', 'Gonzalo',
    'Esteban', 'Rafael', 'Joaquín', 'Marcos', 'Víctor', 'Leonardo', 'Cristian', 'Eduardo', 'Ángel', 'Ricardo',
    'Fernando', 'Hugo', 'Patricio', 'Bruno', 'Maximiliano', 'Iván', 'Claudio', 'Enzo', 'Damián', 'Nahuel'
];

const femaleNames = [
    'María', 'Ana', 'Sofía', 'Laura', 'Lucía', 'Clara', 'Valentina', 'Paula', 'Isabella', 'Luisa',
    'Camila', 'Victoria', 'Mía', 'Julieta', 'Emma', 'Martina', 'Florencia', 'Catalina', 'Natalia', 'Agustina',
    'Elena', 'Carolina', 'Valeria', 'Gabriela', 'Rocío', 'Cecilia', 'Andrea', 'Mercedes', 'Sol', 'Jazmín',
    'Renata', 'Delfina', 'Constanza', 'Pilar', 'Romina', 'Sabrina', 'Mariana', 'Lourdes', 'Antonella', 'Candela',
    'Irene', 'Estefanía', 'Guadalupe', 'Alejandra', 'Milagros', 'Beatriz', 'Carla', 'Silvia', 'Teresa', 'Maitén'
];

const generateAgentDetails = async (siteSettings) => {
    // Функция для генерации имени из файла имен (как в Binpal)
    const generateNameFromFile = async () => {
        try {
            const namesFileName = siteSettings?.namesFile || 'names.txt';
            // Извлекаем только имя файла, убирая путь (names/ или data/names/)
            let fileOnly = (namesFileName || '').split('/').pop();
            // Убеждаемся, что есть расширение .txt
            if (fileOnly && !fileOnly.endsWith('.txt')) {
                fileOnly = fileOnly + '.txt';
            }
            // Если fileOnly пустой или undefined, используем дефолт
            if (!fileOnly || fileOnly === '.txt') {
                fileOnly = 'names.txt';
            }
            
            console.log('[Chat] Загрузка имен из файла:', namesFileName, 'fileOnly:', fileOnly);
            console.log('[Chat] siteSettings.namesFile:', siteSettings?.namesFile);
            console.log('[Chat] siteSettings:', JSON.stringify(siteSettings, null, 2));
            
            // Используем API endpoint для правильной обработки UTF-8 кодировки
            const candidateUrls = [
                `/api/files/names/${encodeURIComponent(fileOnly)}`, // API endpoint с правильной кодировкой
                `/data/names/${fileOnly}`, // Fallback: data/names/
                `/names/${fileOnly}`, // Fallback: names/
                `/${namesFileName}` // Fallback: прямой путь
            ];

            let text = '';
            let lastError = null;
            for (const url of candidateUrls) {
                try {
                    console.log('[Chat] Попытка загрузить файл:', url);
                    const res = await fetch(url, { cache: 'no-store' });
                    if (!res.ok) {
                        console.warn('[Chat] Ответ не OK:', url, res.status, res.statusText);
                        lastError = new Error(`HTTP ${res.status}: ${res.statusText}`);
                        continue;
                    }
                    // Явно указываем кодировку UTF-8 при чтении текста
                    const body = await res.text();
                    const ct = (res.headers.get('content-type') || '').toLowerCase();
                    const looksLikeHtml = /<html|<!doctype/i.test(body);
                    if ((ct.includes('text/plain') || ct.includes('text') || ct === '') && !looksLikeHtml) {
                        // Убеждаемся, что текст правильно декодирован как UTF-8
                        text = body;
                        console.log('[Chat] Файл успешно загружен:', url, 'размер:', text.length, 'символов');
                        console.log('[Chat] Первые 200 символов:', text.substring(0, 200));
                        break;
                    } else {
                        console.warn('[Chat] Неподходящий content-type или HTML:', url, ct, looksLikeHtml);
                    }
                } catch (err) {
                    console.warn('[Chat] Ошибка при загрузке:', url, err);
                    lastError = err;
                    // try next url
                }
            }

            if (!text) {
                throw new Error(`Файл имен не найден или некорректен. Последняя ошибка: ${lastError?.message || 'неизвестно'}`);
            }

            const namesArray = text.split('\n').map(name => name.trim()).filter(name => name.length > 0 && !/^<\/?[a-z]/i.test(name));
            console.log('[Chat] Распарсено имен:', namesArray.length);
            console.log('[Chat] Первые 5 имен:', namesArray.slice(0, 5));
            
            if (namesArray.length === 0) throw new Error('Файл имен пуст');

            const randomLine = namesArray[Math.floor(Math.random() * namesArray.length)];
            const wordsInLine = randomLine.split(' ').filter(word => word.length > 0);
            if (wordsInLine.length === 0) throw new Error('Пустая строка в файле имен');

            let firstName = wordsInLine[0];
            if (firstName.length <= 3 && wordsInLine.length > 1) {
                firstName += ' ' + wordsInLine[1];
            }
            console.log('[Chat] Выбрано имя:', firstName);
            return firstName;
        } catch (error) {
            console.error('[Chat] Не удалось загрузить имена из файла, используем fallback:', error);
            const isMale = Math.random() < 0.5;
            return isMale
                ? maleNames[Math.floor(Math.random() * maleNames.length)]
                : femaleNames[Math.floor(Math.random() * femaleNames.length)];
        }
    };
    
    const name = await generateNameFromFile();
    const agentNumber = Math.floor(1000 + Math.random() * 9000);
    return { name, agentNumber };
};

const formatMoney = (amount, currency = 'RM', numberFormat = 'comma') => {
    if (!amount || isNaN(amount)) return currency;
    
    const num = parseFloat(amount);
    
    // Принудительное форматирование без зависимости от системной локали
    const parts = num.toFixed(2).split('.');
    const integerPart = parts[0];
    const decimalPart = parts[1];
    
    let formattedAmount;
    if (numberFormat === 'dot') {
        // Европейский формат: 10.294,98
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        formattedAmount = `${formattedInteger},${decimalPart}`;
    } else {
        // Американский формат: 10,294.98
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        formattedAmount = `${formattedInteger}.${decimalPart}`;
    }
    
    return `${formattedAmount} ${currency}`;
};

// Функция для расчета суммы в USD через курс USDC из настроек
const calculateUSDAmount = (localAmount, usdcRate = 4.23) => {
    try {
        // Используем курс USDC из настроек (1 USD = X местной валюты)
        const usdAmount = localAmount / usdcRate;
        const roundedAmount = Math.round(usdAmount);
        // Принудительное форматирование без зависимости от системной локали
        return roundedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } catch (error) {
        console.error('Ошибка расчета USD через USDC курс:', error);
        // В случае ошибки используем запасной курс 4.23
        const fallbackRate = 4.23;
        const usdAmount = localAmount / fallbackRate;
        const roundedAmount = Math.round(usdAmount);
        return roundedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
};

// Функция для форматирования даты в чате (ВСЕГДА только дата, без времени)
const formatChatDate = (date, dateTimeSettings, timezone) => {
    const settings = dateTimeSettings || {
        dateFormat: 'dd/MM/yyyy'
    };
    
    // В чате ВСЕГДА только дата, никогда не время
    const dateFormatOptions = {
        timeZone: timezone || 'Asia/Kuala_Lumpur',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    };
    
    // Форматируем дату
    const formatter = new Intl.DateTimeFormat('en-GB', dateFormatOptions);
    let formattedDate = formatter.format(date);
    
    // Применяем кастомное форматирование в зависимости от выбранного формата
    const dateFormat = settings.dateFormat || 'dd/MM/yyyy';
    if (dateFormat === 'MM/dd/yyyy') {
        // Американский формат: MM/DD/YYYY
        const parts = formattedDate.split('/');
        if (parts.length >= 3) {
            formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
        }
    } else if (dateFormat === 'yyyy-MM-dd') {
        // ISO формат: YYYY-MM-DD
        const parts = formattedDate.split('/');
        if (parts.length >= 3) {
            formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
    } else if (dateFormat === 'dd.MM.yyyy') {
        // Немецкий формат с точками: DD.MM.YYYY
        formattedDate = formattedDate.replace(/\//g, '.');
    } else if (dateFormat === 'dd-MM-yyyy') {
        // Формат с дефисами: DD-MM-YYYY
        formattedDate = formattedDate.replace(/\//g, '-');
    }
    // По умолчанию остается DD/MM/YYYY
    
    return formattedDate;
};

const replacePlaceholders = async (text, nameUser, cryptoAdress, maxTotalMoney, network, agentName, commissionAmount, verificationAmount, verifyModalAmount, taxPercent, presetIndex, baseAmount, additionalAmount, currencyFormat = 'RM', numberFormat = 'comma', baseMoneyAmount, additionalMoneyAmount, tariffVerificationAmount, usdcRate = 4.23, siteSettings = {}) => {
    const taxAmount = verifyModalAmount * (taxPercent / 100);
    
    // Определяем правильные значения в зависимости от пресета
    let dineroValue, montoDeRetiroValue, summaVDollarahValue, verifSum;
    
    // Сумма верификации - используем динамическое значение
    verifSum = formatMoney(verificationAmount, currencyFormat, numberFormat);
    
    // Новые переменные для разных типов сумм
    const moneyValue = formatMoney(baseMoneyAmount || maxTotalMoney, currencyFormat, numberFormat); // Только базовая сумма
    const moneyAndAdditionalValue = formatMoney((baseMoneyAmount || maxTotalMoney) + (additionalMoneyAmount || 0), currencyFormat, numberFormat); // Базовая + дополнительная
    const moneyFullValue = formatMoney((baseMoneyAmount || maxTotalMoney) + (additionalMoneyAmount || 0) + (tariffVerificationAmount || verificationAmount), currencyFormat, numberFormat); // Базовая + дополнительная + верификация тарифа
    
    switch (presetIndex) {
        case 0: // ВЕРИФ - показываем полную сумму (verifyModalAmount)
            dineroValue = formatMoney(verifyModalAmount, currencyFormat, numberFormat);
            montoDeRetiroValue = formatMoney(verifyModalAmount, currencyFormat, numberFormat);
            summaVDollarahValue = calculateUSDAmount(verifyModalAmount, usdcRate);
            break;
        case 1: // КОМСА - dinero = verifyModalAmount, monto = maxTotalMoney
            dineroValue = formatMoney(verifyModalAmount, currencyFormat, numberFormat);
            montoDeRetiroValue = formatMoney(maxTotalMoney, currencyFormat, numberFormat);
            summaVDollarahValue = calculateUSDAmount(maxTotalMoney, usdcRate);
            break;
        case 2: // НАЛОГ - dinero = verifyModalAmount, monto = maxTotalMoney
            dineroValue = formatMoney(verifyModalAmount, currencyFormat, numberFormat);
            montoDeRetiroValue = formatMoney(maxTotalMoney, currencyFormat, numberFormat);
            summaVDollarahValue = calculateUSDAmount(maxTotalMoney, usdcRate);
            break;
        case 3: // ПЕРЕВОД НА ПН - для этого пресета используем MONEY+ADD AMOUNT+VERIF MONEYBACK
            const fullAmountWithVerif = (baseMoneyAmount || maxTotalMoney) + (additionalMoneyAmount || 0) + (tariffVerificationAmount || verificationAmount);
            dineroValue = formatMoney(verifyModalAmount, currencyFormat, numberFormat);
            montoDeRetiroValue = formatMoney(verifyModalAmount, currencyFormat, numberFormat);
            summaVDollarahValue = calculateUSDAmount(fullAmountWithVerif, usdcRate);
            break;
        default:
            dineroValue = formatMoney(verifyModalAmount, currencyFormat, numberFormat);
            montoDeRetiroValue = formatMoney(maxTotalMoney, currencyFormat, numberFormat);
            summaVDollarahValue = calculateUSDAmount(maxTotalMoney, usdcRate);
    }
    
    return text
        .replace(/<CLIENT NAME>|<USER NAME>/g, nameUser || '')
        .replace(/<SUPPORT NAME>/g, agentName || '')
        .replace(/<MONEY AND ADDITIONAL AMOUNT>/g, moneyAndAdditionalValue) // Новая переменная: базовая + дополнительная
        .replace(/<MONEY\+ADD AMOUNT\+VERIF MONEYBACK>/g, moneyFullValue) // Новая переменная: базовая + дополнительная + верификация
        .replace(/<MONEY>/g, moneyValue) // Теперь показывает только базовую сумму
        .replace(/<WITHDRAWAL AMOUNT>/g, montoDeRetiroValue)
        .replace(/<CBU\/CVU>/g, cryptoAdress || '')
        .replace(/<BANK>/g, network || '')
        .replace(/<ACCOUNT NUMBER>/g, cryptoAdress || '')
        .replace(/<YESTERDAY DATE>/g, formatChatDate(new Date(Date.now() - 24 * 60 * 60 * 1000), siteSettings.dateTimeSettings, siteSettings.timezone))
        .replace(/<VERIF SUM>/g, verifSum)
        .replace(/<COMMISSION AMOUNT>/g, formatMoney(commissionAmount, currencyFormat, numberFormat))
        .replace(/<TODAY DATE>/g, formatChatDate(new Date(), siteSettings.dateTimeSettings, siteSettings.timezone))
        .replace(/<USD AMOUNT>/g, summaVDollarahValue)
        .replace(/<TAX_PERCENT>/g, taxPercent ? `${taxPercent}%` : '')
        .replace(/<TAX_AMOUNT>/g, formatMoney(taxAmount, currencyFormat, numberFormat))
        .replace(/<CRYPTO_CONVERT_AMOUNT>/g, formatMoney(baseAmount || 0, currencyFormat, numberFormat))
        .replace(/<BANK_CONVERT_AMOUNT>/g, formatMoney(additionalAmount || 0, currencyFormat, numberFormat));
};

const generateTimestamps = (messages) => {
    return messages.map((msg) => ({ ...msg }));
};

const Chat = ({ setShowChat, nameUser, cryptoAdress, maxTotalMoney, network, commissionAmount, verificationAmount, verifyModalAmount, taxPercent, baseAmount, additionalAmount, currencyFormat, siteSettings, baseMoneyAmount, additionalMoneyAmount, tariffVerificationAmount, isNavbarCollapsed }) => {
    // Nova-скин: чат порталится в Nova-рут (каскад токенов), PNG/SVG-иконки
    // заменяются на lucide. Классические темы не затрагиваются
    const isNova = siteSettings?.theme === 'nova';

    // Время сообщения по ГЕО конфига (timezone) с учётом формата 12h/24h
    const formatChatTime = (date) => {
        const tf = siteSettings?.dateTimeSettings?.timeFormat || '24h';
        try {
            return new Intl.DateTimeFormat(tf === '12h' ? 'en-US' : 'en-GB', {
                timeZone: siteSettings?.timezone || 'Asia/Kuala_Lumpur',
                hour: '2-digit',
                minute: '2-digit',
                hour12: tf === '12h',
            }).format(date);
        } catch (_) {
            return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' }).format(date);
        }
    };

    // Lucide-глифы пресетов по их id (в классике — старые PNG)
    const novaPresetGlyphs = {
        verification: ShieldCheck,
        commission: Percent,
        tax: ReceiptText,
        transfer: ArrowLeftRight,
    };
    const renderPresetIcon = (preset) => {
        if (isNova) {
            const Glyph = novaPresetGlyphs[preset.id] || MessagesSquare;
            return (
                <span className={styles.presetGlyph} aria-hidden="true">
                    <Glyph size={15} strokeWidth={2} />
                </span>
            );
        }
        return <img src={getPresetIcon(preset)} alt={preset.name} className={styles.presetIcon} />;
    };
    
    // Функция для получения сообщения чата из настроенных пресетов
    const getChatMessage = (presetType, messageNum, author = 'Support') => {
        const currentLanguage = siteSettings?.currentLanguage || 'ru';
        
        // Сначала пытаемся найти сообщение в настроенных пресетах
        const chatPresets = siteSettings?.chatPresets || [];
        const targetPreset = chatPresets.find(preset => preset.id === presetType);
        
        if (targetPreset && targetPreset.messages && targetPreset.messages[messageNum - 1]) {
            return { 
                author, 
                text: targetPreset.messages[messageNum - 1].text 
            };
        }
        
        // Fallback - дефолтные сообщения
        const defaultMessages = {
            verification: {
                1: { ru: 'Добро пожаловать! Меня зовут <SUPPORT NAME>, и я здесь, чтобы помочь вам. Как я могу помочь вам сегодня?', en: 'Welcome! My name is <SUPPORT NAME>, and I am here to help you. How can I help you today?', ms: 'Selamat datang! Nama saya <SUPPORT NAME>, dan saya di sini untuk membantu anda. Bagaimana saya boleh membantu anda hari ini?' },
                2: { ru: 'Добрый день. Мне нужно узнать о моем клиенте <CLIENT NAME>. Мы пытаемся обработать перевод в размере <MONEY> на их счет <CBU/CVU> в <BANK>. Был запрошен платеж для верификации. Можете ли вы объяснить причину этого требования?', en: 'Good day. I need to inquire about my client <CLIENT NAME>. We are trying to process a transfer of <MONEY> to their account <CBU/CVU> at <BANK>. A verification payment has been requested. Could you explain the rationale behind this requirement?', ms: 'Selamat sejahtera. Saya perlu bertanya tentang pelanggan saya <CLIENT NAME>. Kami sedang cuba memproses pemindahan sebanyak <MONEY> ke akaun mereka <CBU/CVU> di <BANK>. Pembayaran pengesahan telah diminta. Bolehkah anda menjelaskan rasional di sebalik keperluan ini?' }
                // ... другие сообщения
            }
            // ... другие пресеты
        };
        
        const fallbackMessage = defaultMessages[presetType]?.[messageNum]?.[currentLanguage] || 
                               defaultMessages[presetType]?.[messageNum]?.['ru'] || 
                               'Сообщение не найдено';
        
        return { author, text: fallbackMessage };
    };
    
    // Функция для получения переведенного UI текста чата
    const getChatUIText = (textKey) => {
        const currentLanguage = siteSettings?.currentLanguage || 'ru';
        
        // Пытаемся получить переведенный текст из настроек
        const translatedText = siteSettings?.translations?.[currentLanguage]?.chat?.ui?.[textKey];
        
        if (translatedText) {
            return translatedText;
        }
        
        // Fallback - дефолтные тексты
        const defaultTexts = {
            reminderNotification: {
                ru: 'НЕ ЗАБЫВАЕМ МЕНЯТЬ ИМЯ ЮЗЕРА И ЕГО ДАННЫЕ!',
                en: 'НЕ ЗАБЫВАЕМ МЕНЯТЬ ИМЯ ЮЗЕРА И ЕГО ДАННЫЕ!',
                ms: 'НЕ ЗАБЫВАЕМ МЕНЯТЬ ИМЯ ЮЗЕРА И ЕГО ДАННЫЕ!'
            },
            clearChatButton: {
                ru: 'Очистить чат',
                en: 'Очистить чат', 
                ms: 'Очистить чат'
            },
            sendFromYou: {
                ru: 'Отправить от себя',
                en: 'Отправить от себя',
                ms: 'Отправить от себя'
            },
            sendFromSupport: {
                ru: 'Отправить от саппорта',
                en: 'Отправить от саппорта',
                ms: 'Отправить от саппорта'
            },
            cancel: {
                ru: 'Отмена',
                en: 'Отмена',
                ms: 'Отмена'
            },
            messagePlaceholder: {
                ru: 'Введите сообщение...',
                en: 'Type your message...',
                ms: 'Taip mesej anda...'
            }
        };
        
        return defaultTexts[textKey]?.[currentLanguage] || 
               defaultTexts[textKey]?.['ru'] || 
               'Текст не найден';
    };

    // Функция для получения массива пресетов из настроек с учетом языка
    const getChatPresets = () => {
        const currentLanguage = siteSettings?.currentLanguage || 'ru';
        
        // Получаем пресеты из настроек сайта
        const chatPresets = siteSettings?.chatPresets || [];
        
        // Фильтруем только включенные пресеты
        const enabledPresets = chatPresets.filter(preset => preset.enabled);
        
        // Если нет настроенных пресетов, используем дефолтные
        if (enabledPresets.length === 0) {
            return getDefaultPresets();
        }
        
        // Используем пресеты из настроек как есть, без попытки перевода
        // Сообщения уже должны быть на нужном языке в настройках
        return enabledPresets.map(preset => {
            // Получаем переведенное название пресета (если есть)
            const presetType = preset.id; // commission, verification, tax, transfer
            const translatedName = siteSettings?.translations?.[currentLanguage]?.chat?.ui?.presetButtons?.[presetType] || preset.name;
            
            return {
                ...preset,
                name: translatedName,
                // Используем сообщения из настроек как есть
                messages: preset.messages || []
            };
        });
    };

    // Функция для получения иконки пресета
    const getPresetIcon = (preset) => {
        // Если у пресета есть своя иконка, используем её
        if (preset.icon) {
            // Если это полный путь к файлу, используем как есть
            if (preset.icon.startsWith('http') || preset.icon.startsWith('/')) {
                return preset.icon;
            }
            
            // Если это имя файла, пытаемся найти соответствующую импортированную иконку
            const iconMap = {
                'verification_modal.png': verificationModalIcon,
                'comission_modal.png': commissionModalIcon,
                'tax_modal.png': taxModalIcon,
                'name_user_and_chat_preset.png': nameUserChatIcon
            };
            
            return iconMap[preset.icon] || nameUserChatIcon;
        }
        
        // Дефолтная иконка на основе ID пресета
        const defaultIcons = {
            'verification': verificationModalIcon,
            'commission': commissionModalIcon,
            'tax': taxModalIcon,
            'transfer': nameUserChatIcon
        };
        
        return defaultIcons[preset.id] || nameUserChatIcon;
    };

    // Дефолтные пресеты для обратной совместимости (если нет настроенных пресетов)
    const getDefaultPresets = () => {
        return [
            {
                id: 'verification',
                name: 'ВЕРИФ ПРЕСЕТ',
                icon: verificationModalIcon,
                messages: [
                    { author: 'Support', text: 'Добро пожаловать! Меня зовут <SUPPORT NAME>, и я здесь, чтобы помочь вам. Как я могу помочь вам сегодня?' },
                    { author: 'You', text: 'Добрый день. Мне нужно узнать о моем клиенте <CLIENT NAME>. Мы пытаемся обработать перевод в размере <MONEY> на их счет <CBU/CVU> в <BANK>. Был запрошен платеж для верификации. Можете ли вы объяснить причину этого требования?' },
                    { author: 'Support', text: 'Я извиняюсь за любые неудобства. Позвольте мне проверить это для вас и подтвердить детали вашего запроса.' },
                    { author: 'Support', text: 'Я проверил запрос на вывод, поданный от имени <CLIENT NAME> на сумму <MONEY>. Требование верификационного платежа было введено как защитная мера для защиты активов вашего клиента. После успешной верификации и подтверждения того, что информация получателя соответствует данным отправителя, мы продолжим перевод средств на указанный адрес. Эта процедура является важным компонентом нашей комплексной системы безопасности, разработанной для предотвращения несанкционированных транзакций и мошеннической деятельности посредниками, которые могут попытаться перенаправить средства клиентов на несанкционированные счета. Мы ценим ваше понимание и сотрудничество с этими необходимыми протоколами безопасности.\\n\\nОбратите внимание, что после завершения процесса верификации сумма <VERIF SUM> будет автоматически возвращена вместе с выводом ваших средств.' },
                    { author: 'You', text: 'Спасибо за подробное объяснение. Я передам эту информацию своему клиенту.' },
                    { author: 'Support', text: 'Пожалуйста! Если вам понадобится дополнительная помощь, не стесняйтесь обращаться к нам в любое время. Хорошего дня!' }
                ]
            },
            {
                id: 'commission',
                name: 'КОМСА ПРЕСЕТ',
                icon: commissionModalIcon,
                messages: [
                    { author: 'Support', text: 'Доброе утро! Я <SUPPORT NAME> из нашего отдела обслуживания клиентов. Чем могу помочь вам сегодня?' },
                    { author: 'You', text: 'Доброе утро. Мой клиент <USER NAME> недавно завершил процесс верификационного платежа. Однако мы все еще не можем продолжить вывод доходов. Можете ли вы объяснить, что препятствует этой транзакции?' },
                    { author: 'Support', text: 'Приношу извинения за это неудобство. Мы внедрили новую политику вывода средств начиная с <YESTERDAY DATE>. Все выводы теперь имеют стандартную комиссию за обработку для операций между японскими и американскими биржами. Полные детали были отправлены через ваши каналы уведомлений.' },
                    { author: 'You', text: 'Я ценю это объяснение. Однако я хотел бы предложить заранее уведомлять брокеров о таких изменениях политики. Это ставит меня в трудное положение с моими клиентами, когда я не информирован заранее.' },
                    { author: 'Support', text: 'Я понимаю ваши опасения и приношу извинения за неудобства. После оплаты комиссии <WITHDRAWAL AMOUNT> будет переведено на счет <ACCOUNT NUMBER> в <BANK> на имя <CLIENT NAME>. Спасибо за ваше понимание.' },
                    { author: 'Support', text: 'Есть ли что-то еще, с чем я могу помочь вам сегодня?' }
                ]
            },
            {
                id: 'tax',
                name: 'НАЛОГ ПРЕСЕТ',
                icon: taxModalIcon,
                messages: [
                    { author: 'Support', text: 'Добро пожаловать! Я <SUPPORT NAME>, старший специалист по соответствию. Как я могу помочь вам сегодня?' },
                    { author: 'You', text: 'Добрый день. Мне нужно разъяснение относительно налогового сбора IRS, наложенного на моего клиента. Клиент в вопросе - <CLIENT NAME>, и мы пытаемся обработать перевод <WITHDRAWAL AMOUNT> на их счет <CBU/CVU> в <BANK>. Можете ли вы предоставить подробное объяснение нормативной основы для этого налогового требования?' },
                    { author: 'Support', text: 'Конечно. Позвольте мне открыть счет <CLIENT NAME> и просмотреть историю транзакций.' },
                    { author: 'Support', text: 'После проверки я могу подтвердить, что запрос на перевод <WITHDRAWAL AMOUNT> в настоящее время приостановлен до выполнения обязательных налоговых обязательств. Обратите внимание, что с начала этого финансового года наша платформа обязана поддерживать строгое соответствие усиленным международным налоговым стандартам, особенно для трансграничных финансовых транзакций.' },
                    { author: 'You', text: 'Я должен спросить - почему этот налог не требовался раньше? Это второй мой клиент, который должен его платить. Что изменилось в регулировании?' },
                    { author: 'Support', text: 'Ранее это налоговое требование не применялось автоматически. Однако с января этого года было установлено всеобъемлющее многостороннее соглашение между Японией, США и несколькими странами Юго-Восточной Азии как часть скоординированной инициативы по предотвращению уклонения от налогов на криптовалюты.' },
                    { author: 'Support', text: 'Могу ли я помочь вам с чем-то еще по этому вопросу?' },
                    { author: 'You', text: 'Спасибо за исчерпывающее объяснение. Я свяжусь с вами, если у меня возникнут дополнительные вопросы по этому вопросу.' },
                    { author: 'Support', text: 'Спасибо за обращение и спасибо за ваше постоянное сотрудничество. Желаю вам продуктивного дня!' }
                ]
            },
            {
                id: 'transfer',
                name: 'ПЕРЕВОД НА ПН ПРЕСЕТ',
                icon: nameUserChatIcon,
                messages: [
                    { author: 'You', text: 'Добрый день. Мой клиент <CLIENT NAME> недавно завершил процесс верификационного платежа и успешно подтвердил право на свой счет. Однако при попытке обработать вывод средств перевод был заблокирован вашей системой. Можете ли вы объяснить конкретную причину приостановки этой транзакции?' },
                    { author: 'Support', text: 'Спасибо за обращение в нашу команду соответствия. Я понимаю, что этот вопрос требует срочного решения. Дайте мне минуту, чтобы проверить счет вашего клиента и историю транзакций.' },
                    { author: 'Support', text: 'Спасибо за ваше терпение. После тщательной проверки я могу подтвердить, что запрос на вывод составляет <WITHDRAWAL AMOUNT> в <BANK> от <TODAY DATE>. Перевод был временно приостановлен из-за дополнительных процедур верификации, инициированных в соответствии с требованиями Центрального банка под Актом № 25.246 о предотвращении отмывания денег (AML).' },
                    { author: 'You', text: 'Я знаю, что другие клиенты успешно выводили средства в тот же банк. Почему транзакция моего клиента обрабатывается по-другому и подлежит дополнительной проверке?' },
                    { author: 'Support', text: 'Я полностью понимаю ваши опасения, и это действительно обоснованный вопрос. Вы правы, что другие транзакции в <BANK> были успешно обработаны, поскольку процедуры верификации AML применяются не универсально, а на выборочной основе.' },
                    { author: 'You', text: 'Учитывая эту ситуацию, какие альтернативы вы можете предложить для решения этого вопроса?' },
                    { author: 'Support', text: 'Наша главная цель - обеспечить получение вашим клиентом своих средств как можно скорее, и у нас есть несколько доступных альтернативных решений. Наиболее эффективный вариант - обработать вывод в долларах через систему карт UnionPay.' },
                    { author: 'You', text: 'Какую точную сумму получит мой клиент с этим вариантом?' },
                    { author: 'Support', text: 'Вывод составит <USD AMOUNT>. Если вы можете предоставить детали вывода, я могу обработать этот запрос немедленно.' }
                ]
            }
        ];
    };

    // Функция для форматирования чисел согласно настройкам
    const formatNumber = (number, format = 'comma') => {
        if (isNaN(number) || number === null || number === undefined) return '0';
        
        const num = parseFloat(number);
        
        // Принудительное форматирование без зависимости от системной локали
        const parts = num.toFixed(2).split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1];
        
        if (format === 'dot') {
            // Европейский формат: 10.294,98 (точка для тысяч, запятая для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return `${formattedInteger},${decimalPart}`;
        } else {
            // Американский формат: 10,294.98 (запятая для тысяч, точка для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return `${formattedInteger}.${decimalPart}`;
        }
    };
    const [messages, setMessages] = useState(initialMessages);
    const [editingMessage, setEditingMessage] = useState(null);
    const [newMessage, setNewMessage] = useState('');
    // Динамическая позиция в зависимости от состояния NavBar
    const isRTL = siteSettings?.arabicMode || false;
    const calculateInitialX = () => {
        // Nova: рейл 248px / 68px — чат встаёт в 4px от его края
        const navbarWidth = isNova
            ? (isNavbarCollapsed ? 72 : 252)
            : (isNavbarCollapsed ? 72 : 280);
        const chatWidth = isNova ? 352 : 400;
        if (isRTL) {
            // В RTL режиме чат справа, считаем от правого края
            return window.innerWidth - navbarWidth - chatWidth;
        }
        // В LTR режиме чат слева
        return navbarWidth;
    };
    const initialX = calculateInitialX();
    // Nova: чат открывается нижней частью рядом с пунктом меню «Поддержка».
    // На любом экране считаем Y от реального положения кнопки, а не фиксируем.
    const calculateInitialY = () => {
        if (!isNova) return 200;
        const chatHeight = Math.min(600, window.innerHeight - 24);
        const supportBtn = document.querySelector('[data-nova-support]');
        if (supportBtn) {
            const r = supportBtn.getBoundingClientRect();
            // низ окна ~ на уровне низа пункта «Поддержка»
            const y = r.bottom - chatHeight;
            return Math.max(12, Math.min(y, window.innerHeight - chatHeight - 12));
        }
        // фолбэк — прижимаем к низу экрана
        return Math.max(12, window.innerHeight - chatHeight - 90);
    };
    const [position, setPosition] = useState({ x: initialX, y: calculateInitialY() });
    const [dragging, setDragging] = useState(false);
    const [isAuthorPanelOpen, setIsAuthorPanelOpen] = useState(false);
    const [isPresetPanelOpen, setIsPresetPanelOpen] = useState(null);
    const [pendingMessage, setPendingMessage] = useState('');
    const [dragMessageId, setDragMessageId] = useState(null);
    const [dropTargetIndex, setDropTargetIndex] = useState(null);
    // Позиция системной строки «агент присоединился» в ленте Nova
    // (null — авто: перед первым сообщением саппорта)
    const [systemMsgIndex, setSystemMsgIndex] = useState(null);
    // Nova: id сообщения, у которого редактируется время (по клику на время)
    const [editingTimeId, setEditingTimeId] = useState(null);
    const [isEditingAgentName, setIsEditingAgentName] = useState(false);
    const [tempAgentName, setTempAgentName] = useState('');
    const agentNameInputRef = useRef(null);
    const [isEditingAgentNumber, setIsEditingAgentNumber] = useState(false);
    const [tempAgentNumber, setTempAgentNumber] = useState('');
    const agentNumberInputRef = useRef(null);
    const [deletedMessage, setDeletedMessage] = useState(null);
    const [countdown, setCountdown] = useState(null);
    const [agentDetails, setAgentDetails] = useState({ name: 'Agent', agentNumber: 1000 });

    const getAuditContext = (extra = {}) => ({
        userName: nameUser || '',
        bankAccount: cryptoAdress || '',
        withdrawalAmount: maxTotalMoney || '',
        bank: network?.name || network || '',
        agentName: agentDetails.name,
        agentNumber: agentDetails.agentNumber,
        messagesCount: messages.length,
        ...extra
    });

    const auditChat = (action, label, details = {}) => {
        logAudit('support_chat', action, label, getAuditContext(details));
    };

    useEffect(() => {
        auditChat('open', 'Открыт чат поддержки');
        return () => {
            auditChat('close_unmount', 'Чат поддержки размонтирован');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Обновляем позицию чата при изменении состояния NavBar
    useEffect(() => {
        const newX = calculateInitialX();
        setPosition(prev => ({ ...prev, x: newX }));
    }, [isNavbarCollapsed, isRTL]);
    const [selectedAuthorIndex, setSelectedAuthorIndex] = useState(0);
    const [hasSupportJoined, setHasSupportJoined] = useState(false);
    const chatContainerRef = useRef(null);
    const authorPanelRef = useRef(null);
    const presetPanelRef = useRef(null);
    const countdownTimerRef = useRef(null);
    const messageRefs = useRef([]);
    // Nova: refs рядов ленты (сообщения + системная строка) и «призрак» слота вставки
    const itemRefs = useRef([]);
    const dropGhostRef = useRef(null);
    const inputRef = useRef(null);

    // Лента Nova как список рядов: системная строка — полноценный ряд,
    // который можно перетаскивать наравне с сообщениями
    const firstSupportIdx = messages.findIndex(m => m.author === 'Support');
    const chatItems = [];
    if (isNova && messages.length > 0) {
        const anchor = systemMsgIndex !== null
            ? Math.min(systemMsgIndex, messages.length)
            : firstSupportIdx;
        messages.forEach((m, i) => {
            if (firstSupportIdx !== -1 && i === anchor) chatItems.push({ type: 'system' });
            chatItems.push({ type: 'msg', msg: m });
        });
        if (firstSupportIdx !== -1 && anchor >= messages.length) chatItems.push({ type: 'system' });
    }

    const scrollToBottom = () => {
        chatContainerRef.current?.scrollTo({
            top: chatContainerRef.current.scrollHeight,
            behavior: 'smooth',
        });
    };

    // Инициализация агента при загрузке компонента
    useEffect(() => {
        const initializeAgent = async () => {
            const details = await generateAgentDetails(siteSettings);
            setAgentDetails(details);
        };
        initializeAgent();
    }, [siteSettings]);

    useEffect(() => {
        if (messages.length > 0 && !editingMessage && !dragMessageId && !deletedMessage) {
            scrollToBottom();
        }
    }, [messages.length]);

    useEffect(() => {
        const updateMessages = async () => {
            const updatedMessages = await Promise.all(
                messages.map(async (msg) => ({
                    ...msg,
                    text: msg.originalText
                        ? await replacePlaceholders(msg.originalText, nameUser, cryptoAdress, maxTotalMoney, network, agentDetails.name, commissionAmount, verificationAmount, verifyModalAmount, taxPercent, msg.presetIndex, baseAmount, additionalAmount, currencyFormat, siteSettings?.numberFormat, baseMoneyAmount, additionalMoneyAmount, tariffVerificationAmount, siteSettings?.cryptoRates?.USDC || 4.23, siteSettings)
                        : msg.text,
                }))
            );
            setMessages(updatedMessages);
        };
        
        updateMessages();
    }, [nameUser, cryptoAdress, maxTotalMoney, network, agentDetails.name, commissionAmount, verificationAmount, verifyModalAmount, taxPercent, baseAmount, additionalAmount, currencyFormat]);

    // Перетаскивание: во время драга позиция пишется напрямую в style
    // (без ре-рендеров и без CSS-transition), состояние коммитится на mouseup
    const chatWindowRef = useRef(null);
    const dragStateRef = useRef(null);
    const dragRafRef = useRef(0);

    const handleMouseDown = (e) => {
        if (e.target.closest(`.${styles.closeButton}`)) return;
        if (e.button !== 0) return;
        const el = chatWindowRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        dragStateRef.current = {
            relX: e.clientX - rect.left,
            relY: e.clientY - rect.top,
            width: rect.width,
            height: rect.height,
            lastX: rect.left,
            lastY: rect.top,
        };
        el.style.transition = 'none';
        setDragging(true);
        e.stopPropagation();
        e.preventDefault();
    };

    useEffect(() => {
        if (!dragging) return;
        const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
        const onMove = (e) => {
            const st = dragStateRef.current;
            const el = chatWindowRef.current;
            if (!st || !el) return;
            const pad = isNova ? 12 : 0;
            st.lastX = clamp(e.clientX - st.relX, 0, Math.max(0, window.innerWidth - st.width));
            st.lastY = clamp(e.clientY - st.relY, pad, Math.max(pad, window.innerHeight - st.height - pad));
            if (!dragRafRef.current) {
                dragRafRef.current = requestAnimationFrame(() => {
                    dragRafRef.current = 0;
                    el.style.left = `${st.lastX}px`;
                    el.style.right = 'auto';
                    el.style.top = `${st.lastY}px`;
                });
            }
            e.preventDefault();
        };
        const onUp = () => {
            const st = dragStateRef.current;
            const el = chatWindowRef.current;
            if (dragRafRef.current) {
                cancelAnimationFrame(dragRafRef.current);
                dragRafRef.current = 0;
            }
            if (el) el.style.transition = '';
            if (st) setPosition({ x: st.lastX, y: st.lastY });
            dragStateRef.current = null;
            setDragging(false);
            inputRef.current?.focus();
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        return () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
    }, [dragging, isNova]);

    // Nova: растягивание окна за правый верхний угол. Ширина растёт вправо,
    // высота — вверх (нижний край остаётся на месте). Пишем в style напрямую
    // через rAF, позиция коммитится в состояние на отпускании
    const handleResizeStart = (e) => {
        if (e.button !== 0) return;
        const el = chatWindowRef.current;
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        const rect = el.getBoundingClientRect();
        const startX = e.clientX;
        const startY = e.clientY;
        let raf = 0;
        let lastX = startX;
        let lastY = startY;
        const apply = () => {
            raf = 0;
            const w = Math.min(640, Math.max(300, rect.width + (lastX - startX)));
            let h = Math.min(window.innerHeight - 24, Math.max(340, rect.height - (lastY - startY)));
            let top = rect.top + (rect.height - h);
            if (top < 12) {
                top = 12;
                h = rect.top + rect.height - 12;
            }
            el.style.width = `${w}px`;
            el.style.height = `${h}px`;
            el.style.maxHeight = 'none';
            el.style.top = `${top}px`;
        };
        const onMove = (ev) => {
            lastX = ev.clientX;
            lastY = ev.clientY;
            if (!raf) raf = requestAnimationFrame(apply);
            ev.preventDefault();
        };
        const onUp = () => {
            window.removeEventListener('pointermove', onMove);
            window.removeEventListener('pointerup', onUp);
            if (raf) cancelAnimationFrame(raf);
            const r = el.getBoundingClientRect();
            setPosition((p) => ({ ...p, y: r.top }));
        };
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
    };

    // Nova: подсказка «есть куда крутить» — фейд контента у верх/низ края поля
    const [inputFade, setInputFade] = useState({ up: false, down: false });
    const updateInputFades = (el) => {
        const up = el.scrollTop > 1;
        const down = el.scrollTop + el.clientHeight < el.scrollHeight - 1;
        setInputFade((prev) => (prev.up === up && prev.down === down ? prev : { up, down }));
    };

    // Nova: строка ввода растёт по высоте под текст (до потолка, дальше скролл)
    useEffect(() => {
        if (!isNova) return;
        const el = inputRef.current;
        if (!el || el.tagName !== 'TEXTAREA') return;
        el.style.height = 'auto';
        el.style.height = `${Math.min(el.scrollHeight, 132)}px`;
        updateInputFades(el);
    }, [newMessage, isNova]);

    const handleEditMessage = (id) => {
        // Клик сразу после перетаскивания — не редактирование
        if (suppressClickRef.current) return;
        const messageToEdit = messages.find((msg) => msg.id === id);
        auditChat('message_edit_open', 'Открыто редактирование сообщения', {
            message: messageToEdit || null
        });
        setEditingMessage(messageToEdit);
        setNewMessage(messageToEdit.text);
        inputRef.current?.focus();
    };

    // Nova: сохранение времени сообщения, отредактированного по клику
    const commitTimeEdit = (id, value) => {
        setEditingTimeId(null);
        const next = value.trim();
        const before = messages.find((m) => m.id === id);
        if (!before || next === (before.timeText || '')) return;
        auditChat('message_time_edit', 'Изменено время сообщения', {
            message: before,
            timeAfter: next,
        });
        setMessages(messages.map((m) => (m.id === id ? { ...m, timeText: next } : m)));
    };

    const handleSaveMessage = (id) => {
        const before = messages.find((msg) => msg.id === id);
        const updatedMessages = messages.map((msg) =>
            msg.id === id
                ? { ...msg, text: newMessage, originalText: newMessage }
                : msg
        );
        auditChat('message_edit_save', 'Сохранено редактирование сообщения', {
            before,
            afterText: newMessage
        });
        setMessages(generateTimestamps(updatedMessages));
        setEditingMessage(null);
        setNewMessage('');
        inputRef.current?.focus();
    };

    const handleAddMessage = async (author) => {
        if (pendingMessage.trim() !== '') {
            const isFirstSupportMessage = author === 'Support' && !messages.some(msg => msg.author === 'Support');
            const newMsg = {
                id: messages.length + 1,
                author,
                    text: await replacePlaceholders(pendingMessage, nameUser, cryptoAdress, maxTotalMoney, network, agentDetails.name, commissionAmount, verificationAmount, verifyModalAmount, taxPercent, 0, baseAmount, additionalAmount, currencyFormat, siteSettings?.numberFormat, baseMoneyAmount, additionalMoneyAmount, tariffVerificationAmount, siteSettings?.cryptoRates?.USDC || 4.23, siteSettings), // Assuming default preset for new messages
                originalText: pendingMessage,
                presetIndex: 0, // Default preset for new messages
                // Ручное сообщение (с нуля или дописанное к пресету) — текущее время по гео конфига
                timeText: formatChatTime(new Date()),
            };
            const updatedMessages = [...messages, newMsg];
            auditChat('message_send', 'Отправлено сообщение в чате', {
                author,
                pendingMessage,
                message: newMsg,
                messagesBefore: messages
            });
            setMessages(generateTimestamps(updatedMessages));
            if (isFirstSupportMessage) {
                setHasSupportJoined(true);
            }
            setPendingMessage('');
            setIsAuthorPanelOpen(false);
            setSelectedAuthorIndex(0);
            inputRef.current?.focus();
        }
    };

    const handleOpenPanel = () => {
        if (editingMessage) {
            auditChat('send_button_click_edit_mode', 'Нажата кнопка отправки в режиме редактирования', {
                editingMessage,
                newMessage
            });
            handleSaveMessage(editingMessage.id);
        } else if (newMessage.trim() !== '') {
            auditChat('send_button_click_message', 'Нажата кнопка отправки сообщения', {
                typedMessage: newMessage
            });
            setPendingMessage(newMessage);
            setNewMessage('');
            setIsAuthorPanelOpen(true);
            setSelectedAuthorIndex(0);
        } else {
            auditChat('send_button_click_presets', 'Открыта панель пресетов', {
                availablePresets: getChatPresets().map(preset => ({
                    id: preset.id,
                    name: preset.name,
                    messages: preset.messages || []
                }))
            });
            setIsPresetPanelOpen(true);
        }
    };

    const handleInputKeyDown = (e) => {
        // Shift+Enter в textarea — перенос строки, обычный Enter — отправка
        if (e.key === 'Enter' && e.shiftKey) return;
        if (e.key === 'Enter' && newMessage.trim() === '') {
            e.preventDefault();
            return;
        }
        if (e.key === 'Enter' && newMessage.trim() !== '') {
            e.preventDefault();
            auditChat('message_enter_key', 'Сообщение подготовлено клавишей Enter', {
                typedMessage: newMessage
            });
            setPendingMessage(newMessage);
            setNewMessage('');
            setIsAuthorPanelOpen(true);
            setSelectedAuthorIndex(0);
        }
    };

    const handleAuthorPanelKeyDown = (e) => {
        if (!isAuthorPanelOpen) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setSelectedAuthorIndex((prev) => (prev < 2 ? prev + 1 : 0));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setSelectedAuthorIndex((prev) => (prev > 0 ? prev - 1 : 2));
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (selectedAuthorIndex === 0) {
                auditChat('author_select', 'Выбран автор отправки: You', {
                    author: 'You',
                    pendingMessage
                });
                handleAddMessage('You');
            } else if (selectedAuthorIndex === 1) {
                auditChat('author_select', 'Выбран автор отправки: Support', {
                    author: 'Support',
                    pendingMessage
                });
                handleAddMessage('Support');
            } else if (selectedAuthorIndex === 2) {
                auditChat('author_select_cancel', 'Отменён выбор автора отправки', {
                    pendingMessage
                });
                setIsAuthorPanelOpen(false);
                setSelectedAuthorIndex(0);
                inputRef.current?.focus();
            }
        }
    };

    const handleSelectPreset = async (presetIndex) => {
        const chatPresets = getChatPresets();
        const selectedPreset = chatPresets[presetIndex];
        
        if (!selectedPreset || !selectedPreset.messages) {
            console.warn('Пресет не найден или не содержит сообщений:', presetIndex);
            return;
        }

        const newMessages = await Promise.all(
            selectedPreset.messages.map(async (msg, idx) => ({
                id: idx + 1,
                author: msg.author,
                                    text: await replacePlaceholders(msg.text, nameUser, cryptoAdress, maxTotalMoney, network, agentDetails.name, commissionAmount, verificationAmount, verifyModalAmount, taxPercent, presetIndex, baseAmount, additionalAmount, currencyFormat, siteSettings?.numberFormat, baseMoneyAmount, additionalMoneyAmount, tariffVerificationAmount, siteSettings?.cryptoRates?.USDC || 4.23, siteSettings),
                originalText: msg.text,
                presetIndex: presetIndex, // Store preset index
                presetId: selectedPreset.id, // Store preset ID
            }))
        );
        // Времена пресета по гео конфига: последнее сообщение — текущее время,
        // каждое предыдущее раньше следующего на взвешенно-случайный интервал:
        // чаще всего 1–2 мин (60%), реже 2–3 мин (30%), совсем редко 3–5 мин (10%)
        const randomGapSec = () => {
            const r = Math.random();
            if (r < 0.6) return 60 + Math.random() * 60;
            if (r < 0.9) return 120 + Math.random() * 60;
            return 180 + Math.random() * 120;
        };
        let ts = Date.now();
        for (let i = newMessages.length - 1; i >= 0; i--) {
            newMessages[i].timeText = formatChatTime(new Date(ts));
            ts -= Math.round(randomGapSec()) * 1000;
        }
        auditChat('preset_select', 'Выбран пресет чата', {
            presetIndex,
            presetId: selectedPreset.id,
            presetName: selectedPreset.name,
            originalMessages: selectedPreset.messages,
            renderedMessages: newMessages
        });
        setMessages(generateTimestamps(newMessages));
        setIsPresetPanelOpen(false);
        
        // Генерируем нового агента асинхронно
        generateAgentDetails(siteSettings).then(details => {
            setAgentDetails(details);
        });
        
        setHasSupportJoined(newMessages.some(msg => msg.author === 'Support'));
        inputRef.current?.focus();
    };

    const handleClearChat = () => {
        auditChat('clear_chat', 'Очищен чат', {
            messages
        });
        setMessages(initialMessages);
        setIsPresetPanelOpen(false);
        setHasSupportJoined(false);
        inputRef.current?.focus();
    };

    const handleDragStart = (id) => {
        const message = messages.find((msg) => msg.id === id);
        auditChat('message_drag_start', 'Начато перетаскивание сообщения', {
            message
        });
        setDragMessageId(id);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        if (dragMessageId === null) return;

        const chatRect = chatContainerRef.current.getBoundingClientRect();
        const mouseY = e.clientY - chatRect.top + chatContainerRef.current.scrollTop;

        let targetIndex = messages.length;
        for (let i = 0; i < messageRefs.current.length; i++) {
            if (!messageRefs.current[i]) continue;
            const msgRect = messageRefs.current[i].getBoundingClientRect();
            const msgTop = msgRect.top - chatRect.top + chatContainerRef.current.scrollTop;
            const msgHeight = msgRect.height;
            if (mouseY < msgTop + msgHeight / 2) {
                targetIndex = i;
                break;
            }
        }

        setDropTargetIndex(targetIndex);
    };

    const handleDragEnd = () => {
        setDragMessageId(null);
        setDropTargetIndex(null);
        inputRef.current?.focus();
    };

    const handleDrop = () => {
        if (dragMessageId === null || dropTargetIndex === null) return;
        const draggedMessage = messages.find((msg) => msg.id === dragMessageId);
        const currentIndex = messages.findIndex((msg) => msg.id === dragMessageId);
        if (dropTargetIndex === currentIndex || dropTargetIndex === currentIndex + 1) {
            setDragMessageId(null);
            setDropTargetIndex(null);
            inputRef.current?.focus();
            return;
        }

        const newMessages = messages.filter((msg) => msg.id !== dragMessageId);
        const adjustedIndex = dropTargetIndex > currentIndex ? dropTargetIndex - 1 : dropTargetIndex;
        newMessages.splice(adjustedIndex, 0, draggedMessage);
        const updatedMessages = newMessages.map((msg, index) => ({
            ...msg,
            id: index + 1,
        }));
        auditChat('message_drag_drop', 'Сообщение перемещено в чате', {
            message: draggedMessage,
            fromIndex: currentIndex,
            toIndex: adjustedIndex,
            messagesAfter: updatedMessages
        });
        setMessages(generateTimestamps(updatedMessages));
        setDragMessageId(null);
        setDropTargetIndex(null);
        inputRef.current?.focus();
    };

    // ── Nova: сортировка рядов ленты (сообщения и системная строка) перетаскиванием.
    // Pointer-события вместо HTML5 drag-n-drop: ряд следует за курсором
    // (transform, без ре-рендеров), соседи плавно расступаются, а пунктирный
    // «призрак» показывает слот, куда встанет ряд. Порядок коммитится на mouseup
    const suppressClickRef = useRef(false);

    const handleRowPointerDown = (e, itemIdx) => {
        if (!isNova || e.button !== 0) return;
        // Только мышь: на тач-устройствах вертикальный жест — это скролл ленты
        if (e.pointerType && e.pointerType !== 'mouse') return;
        const container = chatContainerRef.current;
        const el = itemRefs.current[itemIdx];
        if (!container || !el) return;

        const rows = itemRefs.current.slice(0, chatItems.length);
        const startY = e.clientY;
        const startScroll = container.scrollTop;
        const gap = 8;
        const step = el.offsetHeight + gap; // высота ряда + gap ленты
        let active = false;
        let target = itemIdx;
        let raf = 0;
        let lastClientY = startY;

        const applyShifts = () => {
            raf = 0;
            const dy = (lastClientY - startY) + (container.scrollTop - startScroll);
            el.style.transform = `translateY(${dy}px) scale(1.02)`;
            // Куда встанет ряд: считаем соседей, чьи центры выше его центра
            const center = el.offsetTop + el.offsetHeight / 2 + dy;
            let t = 0;
            rows.forEach((node, i) => {
                if (!node || i === itemIdx) return;
                if (node.offsetTop + node.offsetHeight / 2 < center) t++;
            });
            target = t;
            // Соседи между старой и новой позицией расступаются
            rows.forEach((node, i) => {
                if (!node || i === itemIdx) return;
                let shift = 0;
                if (itemIdx < target && i > itemIdx && i <= target) shift = -step;
                else if (target < itemIdx && i >= target && i < itemIdx) shift = step;
                node.style.transform = shift ? `translateY(${shift}px)` : '';
            });
            // Пунктирный призрак — в освободившемся слоте
            const ghost = dropGhostRef.current;
            if (ghost) {
                let slotTop;
                if (target === itemIdx) slotTop = el.offsetTop;
                else if (target > itemIdx) {
                    const n = rows[target];
                    slotTop = n ? n.offsetTop + n.offsetHeight + gap - step : el.offsetTop;
                } else {
                    slotTop = rows[target] ? rows[target].offsetTop : el.offsetTop;
                }
                ghost.style.top = `${slotTop}px`;
                ghost.style.height = `${el.offsetHeight}px`;
            }
        };

        const onMove = (ev) => {
            lastClientY = ev.clientY;
            if (!active) {
                // Порог 6px отделяет перетаскивание от клика-редактирования
                if (Math.abs(ev.clientY - startY) < 6) return;
                active = true;
                suppressClickRef.current = true;
                el.classList.add(styles.reordering);
                rows.forEach((node, i) => {
                    if (!node || i === itemIdx) return;
                    node.style.transition = 'transform 180ms cubic-bezier(0.23, 1, 0.32, 1)';
                });
                if (dropGhostRef.current) dropGhostRef.current.style.display = 'block';
                document.body.style.cursor = 'grabbing';
            }
            // Автоскролл ленты у краёв
            const rect = container.getBoundingClientRect();
            if (ev.clientY < rect.top + 28) container.scrollTop -= 8;
            else if (ev.clientY > rect.bottom - 28) container.scrollTop += 8;
            if (!raf) raf = requestAnimationFrame(applyShifts);
            ev.preventDefault();
        };

        const onUp = () => {
            window.removeEventListener('pointermove', onMove);
            window.removeEventListener('pointerup', onUp);
            if (raf) cancelAnimationFrame(raf);
            document.body.style.cursor = '';
            if (dropGhostRef.current) dropGhostRef.current.style.display = 'none';
            // Снимаем инлайновые стили до коммита: узлы переиспользуются по key
            rows.forEach((node) => {
                if (!node) return;
                node.style.transform = '';
                node.style.transition = '';
            });
            el.classList.remove(styles.reordering);
            if (!active) return;
            // Отпускаем блокировку кликов после того, как отработает click-событие
            setTimeout(() => { suppressClickRef.current = false; }, 0);
            if (target !== itemIdx) {
                // Новый порядок рядов → новый порядок сообщений + позиция системной строки
                const newItems = [...chatItems];
                const [draggedItem] = newItems.splice(itemIdx, 1);
                newItems.splice(target, 0, draggedItem);
                const newMessages = newItems
                    .filter((it) => it.type === 'msg')
                    .map((it, i) => ({ ...it.msg, id: i + 1 }));
                const sysPos = newItems.findIndex((it) => it.type === 'system');
                if (sysPos !== -1) {
                    setSystemMsgIndex(newItems.slice(0, sysPos).filter((it) => it.type === 'msg').length);
                }
                if (draggedItem.type === 'msg') {
                    auditChat('message_drag_drop', 'Сообщение перемещено в чате', {
                        message: draggedItem.msg,
                        fromIndex: itemIdx,
                        toIndex: target,
                        messagesAfter: newMessages,
                    });
                    setMessages(generateTimestamps(newMessages));
                } else {
                    auditChat('system_row_drag_drop', 'Системная строка перемещена в чате', {
                        fromIndex: itemIdx,
                        toIndex: target,
                    });
                }
            }
            inputRef.current?.focus();
        };

        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
    };

    const handleDeleteMessage = (id) => {
        if (suppressClickRef.current) return;
        const messageToDelete = messages.find((msg) => msg.id === id);
        auditChat('message_delete', 'Сообщение удалено из чата', {
            message: messageToDelete,
            index: messages.findIndex((msg) => msg.id === id)
        });
        setDeletedMessage({ ...messageToDelete, index: messages.findIndex((msg) => msg.id === id) });
        const updatedMessages = messages.filter((msg) => msg.id !== id).map((msg, index) => ({
            ...msg,
            id: index + 1,
        }));
        setMessages(generateTimestamps(updatedMessages));
        setCountdown(3);
        setNewMessage('');
        setHasSupportJoined(updatedMessages.some(msg => msg.author === 'Support'));
        inputRef.current?.focus();
    };

    const handleRestoreMessage = () => {
        if (deletedMessage) {
            const newMessages = [...messages];
            newMessages.splice(deletedMessage.index, 0, deletedMessage);
            const updatedMessages = newMessages.map((msg, index) => ({
                ...msg,
                id: index + 1,
            }));
            auditChat('message_restore', 'Сообщение восстановлено в чате', {
                message: deletedMessage,
                messagesAfter: updatedMessages
            });
            setMessages(generateTimestamps(updatedMessages));
            setDeletedMessage(null);
            setCountdown(null);
            setHasSupportJoined(updatedMessages.some(msg => msg.author === 'Support'));
            inputRef.current?.focus();
        }
    };

    useEffect(() => {
        if (countdown !== null && countdown > 0) {
            countdownTimerRef.current = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
        } else if (countdown === 0) {
            setDeletedMessage(null);
            setCountdown(null);
            inputRef.current?.focus();
        }
        return () => clearTimeout(countdownTimerRef.current);
    }, [countdown]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                authorPanelRef.current &&
                !authorPanelRef.current.contains(e.target) &&
                !e.target.closest(`.${styles.sendButton}`)
            ) {
                setIsAuthorPanelOpen(false);
                setSelectedAuthorIndex(0);
                inputRef.current?.focus();
            }
            if (
                presetPanelRef.current &&
                !presetPanelRef.current.contains(e.target) &&
                !e.target.closest(`.${styles.sendButton}`)
            ) {
                setIsPresetPanelOpen(false);
                inputRef.current?.focus();
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (isAuthorPanelOpen && authorPanelRef.current) {
            authorPanelRef.current.focus();
        }
    }, [isAuthorPanelOpen]);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleCloseChat = () => {
        auditChat('close_click', 'Закрыт чат поддержки кнопкой', {
            messages
        });
        if (typeof setShowChat === 'function') {
            setShowChat(false);
        } else {
            console.warn('setShowChat не передан или не является функцией');
        }
    };

    // Функции для редактирования имени агента
    const handleAgentNameDoubleClick = () => {
        auditChat('agent_name_edit_open', 'Открыто редактирование имени агента');
        setIsEditingAgentName(true);
        setTempAgentName(agentDetails.name);
        setTimeout(() => {
            agentNameInputRef.current?.focus();
            agentNameInputRef.current?.select();
        }, 0);
    };

    const handleAgentNameChange = (e) => {
        setTempAgentName(e.target.value);
    };

    const handleAgentNameSubmit = () => {
        if (tempAgentName.trim()) {
            auditChat('agent_name_edit_save', 'Изменено имя агента', {
                from: agentDetails.name,
                to: tempAgentName.trim()
            });
            setAgentDetails(prev => ({
                ...prev,
                name: tempAgentName.trim()
            }));
        }
        setIsEditingAgentName(false);
        setTempAgentName('');
    };

    const handleAgentNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleAgentNameSubmit();
        } else if (e.key === 'Escape') {
            setIsEditingAgentName(false);
            setTempAgentName('');
        }
    };

    const handleAgentNameBlur = () => {
        handleAgentNameSubmit();
    };

    // Функции для редактирования номера агента
    const handleAgentNumberDoubleClick = () => {
        auditChat('agent_number_edit_open', 'Открыто редактирование номера агента');
        setIsEditingAgentNumber(true);
        setTempAgentNumber(agentDetails.agentNumber.toString());
        setTimeout(() => {
            agentNumberInputRef.current?.focus();
            agentNumberInputRef.current?.select();
        }, 0);
    };

    const handleAgentNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Только цифры
        setTempAgentNumber(value);
    };

    const handleAgentNumberSubmit = () => {
        const newNumber = parseInt(tempAgentNumber);
        if (tempAgentNumber.trim() && !isNaN(newNumber) && newNumber > 0) {
            auditChat('agent_number_edit_save', 'Изменён номер агента', {
                from: agentDetails.agentNumber,
                to: newNumber
            });
            setAgentDetails(prev => ({
                ...prev,
                agentNumber: newNumber
            }));
        }
        setIsEditingAgentNumber(false);
        setTempAgentNumber('');
    };

    const handleAgentNumberKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleAgentNumberSubmit();
        } else if (e.key === 'Escape') {
            setIsEditingAgentNumber(false);
            setTempAgentNumber('');
        }
    };

    const handleAgentNumberBlur = () => {
        handleAgentNumberSubmit();
    };

    // Функция для автоматического изменения размера инпута
    const getInputWidth = (text, minWidth = 30, maxWidth = 200) => {
        if (!text) return minWidth;
        // Более точный расчет: 7.5px на символ для шрифта 13px
        const charWidth = 7.5;
        const padding = 12; // padding слева и справа (2px + 6px с каждой стороны)
        const calculatedWidth = (text.length * charWidth) + padding;
        return Math.min(Math.max(calculatedWidth, minWidth), maxWidth);
    };

    // Nova: окно фиксировано от вьюпорта — держим его целиком на экране
    // (высота ограничена в CSS до 100vh - 24px, здесь зажимаем top)
    const novaTop = () => {
        // Если окно растянуто вручную — считаем по фактической высоте
        const actual = chatWindowRef.current?.getBoundingClientRect?.().height;
        const h = actual || Math.min(600, window.innerHeight - 24);
        return Math.max(12, Math.min(position.y, window.innerHeight - h - 12));
    };
    const topPx = isNova ? novaTop() : position.y;

    const chatContent = (
        <>
            {/* Nova: лёгкий бэкдроп с еле заметным блюром за чатом */}
            {isNova && <div className={styles.novaChatScrim} aria-hidden="true" />}
            {countdown !== null && (
                <div className={`${styles.toast} ${isNova ? styles.novaSkin : ''}`}>
                    <div className={styles.countdownCircle}>{countdown}</div>
                                                        <span>Сообщение удалено</span>
                                    <button onClick={handleRestoreMessage}>Восстановить</button>
                </div>
            )}
            <div
                ref={chatWindowRef}
                className={`${styles.chatWindow} ${isNova ? styles.novaSkin : ''}`}
                style={isRTL ? { right: `${window.innerWidth - position.x - (isNova ? 352 : 400)}px`, left: 'auto', top: `${topPx}px` } : { left: `${position.x}px`, right: 'auto', top: `${topPx}px` }}
            >
                {isNova && (
                    <div
                        className={styles.resizeHandle}
                        onPointerDown={handleResizeStart}
                        aria-hidden="true"
                    />
                )}
                <div className={styles.header} onMouseDown={handleMouseDown}>
                    {isNova ? (
                        <span className={styles.novaAvatar} aria-hidden="true">
                            <Headset size={18} strokeWidth={2} />
                            <span className={styles.presenceDot} />
                        </span>
                    ) : (
                        <img src={supportAvatar} alt="Support" className={styles.headerAvatar} />
                    )}
                    <div className={styles.agentInfo}>
                        <span className={styles.agentTitle} style={isNova ? undefined : { color: 'white' }}>
                            {getChatUIText('agentTitle')}
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span className={styles.onlineIndicator}></span>
                            <span className={styles.agentText} style={isNova ? { display: 'flex', alignItems: 'center' } : { color: 'white', display: 'flex', alignItems: 'center' }}>
                                {isEditingAgentName ? (
                                    <input
                                        ref={agentNameInputRef}
                                        type="text"
                                        value={tempAgentName}
                                        onChange={handleAgentNameChange}
                                        onKeyDown={handleAgentNameKeyDown}
                                        onBlur={handleAgentNameBlur}
                                        className={styles.agentNameInput}
                                        style={isNova ? { width: `${getInputWidth(tempAgentName, 50, 150)}px` } : { 
                                            color: 'white', 
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            borderRadius: '4px',
                                            padding: '2px 6px',
                                            fontSize: '13px',
                                            width: `${getInputWidth(tempAgentName, 50, 150)}px`
                                        }}
                                    />
                                ) : (
                                    <span 
                                        style={{ cursor: 'pointer', marginRight: '2px' }}
                                        onDoubleClick={handleAgentNameDoubleClick}
                                        title="Двойной клик для редактирования имени"
                                    >
                                        {agentDetails.name}
                                    </span>
                                )}
                                <span style={{ marginRight: '0px' }}>#</span>
                                {isEditingAgentNumber ? (
                                    <input
                                        ref={agentNumberInputRef}
                                        type="text"
                                        value={tempAgentNumber}
                                        onChange={handleAgentNumberChange}
                                        onKeyDown={handleAgentNumberKeyDown}
                                        onBlur={handleAgentNumberBlur}
                                        className={styles.agentNameInput}
                                        style={isNova ? { width: `${getInputWidth(tempAgentNumber, 35, 80)}px` } : { 
                                            color: 'white', 
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            borderRadius: '4px',
                                            padding: '2px 6px',
                                            fontSize: '13px',
                                            width: `${getInputWidth(tempAgentNumber, 35, 80)}px`
                                        }}
                                    />
                                ) : (
                                    <span 
                                        style={{ cursor: 'pointer' }}
                                        onDoubleClick={handleAgentNumberDoubleClick}
                                        title="Двойной клик для редактирования номера"
                                    >
                                        {agentDetails.agentNumber}
                                    </span>
                                )}
                                <span style={{ marginLeft: '4px' }}>{getChatUIText('agentStatus')}</span>
                            </span>
                        </div>
                    </div>
                    <button className={styles.closeButton} onClick={handleCloseChat}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>

                <div
                    className={styles.messages}
                    ref={chatContainerRef}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                >
                    {messages.length === 0 ? (
                        <div className={styles.emptyChatContainer}>
                            <div className={styles.notification}>
                                <span className={styles.notificationText}>
                                    <span className={styles.exclamation}>🦣 ⇢ 🪪</span>
                                    <br />
                                    {getChatUIText('reminderNotification')}
                                </span>
                            </div>
                            <div className={styles.presetButtons}>
                                {getChatPresets().map((preset, index) => (
                                    <button
                                        key={preset.id}
                                    className={styles.presetButton}
                                        onClick={() => handleSelectPreset(index)}
                                    >
                                        {renderPresetIcon(preset)}
                                        <span className={styles.presetName}>{preset.name}</span>
                                        {isNova && <ChevronRight size={14} strokeWidth={2.2} className={styles.presetChevron} aria-hidden="true" />}
                                </button>
                                ))}
                            </div>
                        </div>
                    ) : isNova ? (
                        <>
                            {chatItems.map((it, itemIdx) => it.type === 'system' ? (
                                <div
                                    key="system-row"
                                    ref={(el) => (itemRefs.current[itemIdx] = el)}
                                    className={styles.systemMessage}
                                    onPointerDown={(e) => handleRowPointerDown(e, itemIdx)}
                                >
                                    <span className={styles.systemText}>
                                        {getChatUIText('agentTitle')} {agentDetails.name} #{agentDetails.agentNumber} {getChatUIText('agentJoinedMessage')}
                                    </span>
                                </div>
                            ) : (
                                <div
                                    key={it.msg.id}
                                    ref={(el) => (itemRefs.current[itemIdx] = el)}
                                    className={`${styles.messageWrapper} ${it.msg.author === 'Support' ? styles.supportWrapper : styles.userWrapper}`}
                                    onPointerDown={(e) => handleRowPointerDown(e, itemIdx)}
                                    onDoubleClick={() => handleDeleteMessage(it.msg.id)}
                                >
                                    <div className={`${styles.message} ${it.msg.author === 'Support' ? styles.support : styles.user}`}>
                                        <div className={styles.messageContent}>
                                            <span
                                                className={styles.text}
                                                onClick={() => handleEditMessage(it.msg.id)}
                                            >
                                                {it.msg.text.split('\\n').map((line, li, array) => (
                                                    <React.Fragment key={li}>
                                                        {line}
                                                        {li < array.length - 1 && <br />}
                                                    </React.Fragment>
                                                ))}
                                            </span>
                                            {(() => {
                                                const isSupport = it.msg.author === 'Support';
                                                const badge = (
                                                    <span className={styles.metaBadge}>
                                                        {isSupport
                                                            ? <Headset size={10} strokeWidth={2.4} aria-hidden="true" />
                                                            : <ShieldCheck size={10} strokeWidth={2.4} aria-hidden="true" />}
                                                        {isSupport ? `Agent #${agentDetails.agentNumber}` : `Broker License: ${siteSettings.brokerLicenseNumber || '918552'}`}
                                                    </span>
                                                );
                                                const time = editingTimeId === it.msg.id ? (
                                                    <input
                                                        className={styles.timeEdit}
                                                        defaultValue={it.msg.timeText || ''}
                                                        autoFocus
                                                        onFocus={(e) => e.target.select()}
                                                        onPointerDown={(e) => e.stopPropagation()}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onDoubleClick={(e) => e.stopPropagation()}
                                                        onKeyDown={(e) => {
                                                            e.stopPropagation();
                                                            if (e.key === 'Enter') e.currentTarget.blur();
                                                            else if (e.key === 'Escape') {
                                                                e.currentTarget.value = it.msg.timeText || '';
                                                                e.currentTarget.blur();
                                                            }
                                                        }}
                                                        onBlur={(e) => commitTimeEdit(it.msg.id, e.currentTarget.value)}
                                                    />
                                                ) : it.msg.timeText ? (
                                                    <span
                                                        className={styles.timeChip}
                                                        title="Клик — изменить время"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (suppressClickRef.current) return;
                                                            setEditingTimeId(it.msg.id);
                                                        }}
                                                        onDoubleClick={(e) => e.stopPropagation()}
                                                    >
                                                        {it.msg.timeText}
                                                    </span>
                                                ) : null;
                                                // В обоих пузырях: бейдж слева, время в правом нижнем углу
                                                return (
                                                    <span className={`${styles.timestamp} ${isSupport ? styles.supportAuthor : styles.userAuthor}`}>
                                                        {badge}{time}
                                                    </span>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* Пунктирный слот-призрак: показывает, куда встанет ряд */}
                            <div className={styles.dropGhost} ref={dropGhostRef} aria-hidden="true" />
                        </>
                    ) : (
                        messages.map((msg, index) => {
                            const firstSupportIndex = messages.findIndex(m => m.author === 'Support');
                            return (
                                <React.Fragment key={msg.id}>
                                    {dropTargetIndex === index && (
                                        <div className={styles.dropIndicator}></div>
                                    )}
                                    {index === firstSupportIndex && msg.author === 'Support' && (
                                        <div className={styles.systemMessage}>
                                            <span className={styles.systemText}>
                                                {getChatUIText('agentTitle')} {agentDetails.name} #{agentDetails.agentNumber} {getChatUIText('agentJoinedMessage')}
                                            </span>
                                        </div>
                                    )}
                                    <div
                                        ref={(el) => (messageRefs.current[index] = el)}
                                        className={`${styles.messageWrapper} ${msg.author === 'Support' ? styles.supportWrapper : styles.userWrapper} ${dragMessageId === msg.id ? styles.dragging : ''} ${dropTargetIndex === index ? styles.dropTarget : ''}`}
                                        draggable
                                        onDragStart={() => handleDragStart(msg.id)}
                                        onDragEnd={handleDragEnd}
                                        onDoubleClick={() => handleDeleteMessage(msg.id)}
                                    >
                                        <div className={`${styles.message} ${msg.author === 'Support' ? styles.support : styles.user}`}>
                                            <div className={styles.messageContent}>
                                                <span
                                                    className={styles.text}
                                                    onClick={() => handleEditMessage(msg.id)}
                                                >
                                                    {msg.text.split('\\n').map((line, index, array) => (
                                                        <React.Fragment key={index}>
                                                            {line}
                                                            {index < array.length - 1 && <br />}
                                                        </React.Fragment>
                                                    ))}
                                                </span>
                                                <span className={`${styles.timestamp} ${msg.author === 'Support' ? styles.supportAuthor : styles.userAuthor}`}>
                                                    {isNova && (msg.author === 'Support'
                                                        ? <Headset size={10} strokeWidth={2.4} aria-hidden="true" />
                                                        : <ShieldCheck size={10} strokeWidth={2.4} aria-hidden="true" />)}
                                                    {msg.author === 'Support' ? `Agent #${agentDetails.agentNumber}` : `Broker License: №${siteSettings.brokerLicenseNumber || '918552'}`}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            );
                        })
                    )}
                    {dropTargetIndex === messages.length && messages.length > 0 && (
                        <div className={styles.dropIndicator}></div>
                    )}

                </div>

                <div className={styles.inputWrapper}>
                    {isNova ? (
                        <div className={`${styles.inputField} ${inputFade.up ? styles.fadeTop : ''} ${inputFade.down ? styles.fadeBottom : ''}`}>
                            <textarea
                                ref={inputRef}
                                className={styles.input}
                                rows={1}
                                placeholder={getChatUIText('messagePlaceholder')}
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                onScroll={(e) => updateInputFades(e.currentTarget)}
                                onBlur={() => {
                                    if (newMessage.trim()) {
                                        auditChat('message_input_blur', 'Завершён ввод сообщения в поле чата', {
                                            typedMessage: newMessage
                                        });
                                    }
                                }}
                                onKeyDown={handleInputKeyDown}
                            />
                        </div>
                    ) : (
                    <input
                        ref={inputRef}
                        className={styles.input}
                        type="text"
                                                                placeholder={getChatUIText('messagePlaceholder')}
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onBlur={() => {
                            if (newMessage.trim()) {
                                auditChat('message_input_blur', 'Завершён ввод сообщения в поле чата', {
                                    typedMessage: newMessage
                                });
                            }
                        }}
                        onKeyDown={handleInputKeyDown}
                    />
                    )}
                    <button className={styles.sendButton} onClick={handleOpenPanel}>
                        {isNova ? (
                            <SendHorizontal size={17} strokeWidth={2} aria-hidden="true" />
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <line x1="22" y1="2" x2="11" y2="13" />
                                <polygon points="22 2 15 22 11 13 2 9 22 2" />
                            </svg>
                        )}
                    </button>
                </div>

                {isAuthorPanelOpen && (
                    <div
                        className={styles.authorPanel}
                        ref={authorPanelRef}
                        tabIndex={0}
                        onKeyDown={handleAuthorPanelKeyDown}
                    >
                        <button
                            onClick={() => {
                                auditChat('author_select', 'Выбран автор отправки: You', {
                                    author: 'You',
                                    pendingMessage
                                });
                                handleAddMessage('You');
                            }}
                            onMouseEnter={() => setSelectedAuthorIndex(0)}
                            onMouseLeave={() => setSelectedAuthorIndex(selectedAuthorIndex)}
                            className={selectedAuthorIndex === 0 ? (isNova ? styles.selected : 'bg-[#4a90e2]') : ''}
                        >
                            {isNova && <UserRound size={14} strokeWidth={2} aria-hidden="true" />}
                            {getChatUIText('sendFromYou')}
                        </button>
                        <button
                            onClick={() => {
                                auditChat('author_select', 'Выбран автор отправки: Support', {
                                    author: 'Support',
                                    pendingMessage
                                });
                                handleAddMessage('Support');
                            }}
                            onMouseEnter={() => setSelectedAuthorIndex(1)}
                            onMouseLeave={() => setSelectedAuthorIndex(selectedAuthorIndex)}
                            className={selectedAuthorIndex === 1 ? (isNova ? styles.selected : 'bg-[#4a90e2]') : ''}
                        >
                            {isNova && <Headset size={14} strokeWidth={2} aria-hidden="true" />}
                            {getChatUIText('sendFromSupport')}
                        </button>
                        <button
                            onClick={() => {
                                auditChat('author_select_cancel', 'Отменён выбор автора отправки', {
                                    pendingMessage
                                });
                                setIsAuthorPanelOpen(false);
                                setSelectedAuthorIndex(0);
                                inputRef.current?.focus();
                            }}
                            onMouseEnter={() => setSelectedAuthorIndex(2)}
                            onMouseLeave={() => setSelectedAuthorIndex(selectedAuthorIndex)}
                            className={selectedAuthorIndex === 2 ? (isNova ? styles.selected : 'bg-[#4a90e2]') : ''}
                        >
                            {getChatUIText('cancel')}
                        </button>
                    </div>
                )}

                {isPresetPanelOpen && (
                    <div className={styles.presetPanel} ref={presetPanelRef}>
                        {getChatPresets().map((preset, index) => (
                            <button 
                                key={preset.id}
                                onClick={() => handleSelectPreset(index)}
                            >
                                {renderPresetIcon(preset)}
                                {preset.name}
                        </button>
                        ))}
                        {messages.length > 0 && (
                            <button onClick={handleClearChat} className={isNova ? styles.dangerItem : ''}>
                                {isNova && <Eraser size={14} strokeWidth={2} aria-hidden="true" />}
                                {getChatUIText('clearChatButton')}
                            </button>
                        )}
                    </div>
                )}
            </div>


        </>
    );

    // В Nova порталим чат внутрь Nova-рута, чтобы работал каскад CSS-токенов
    if (isNova && typeof document !== 'undefined') {
        const novaRoot = document.querySelector('[data-nova-theme]');
        if (novaRoot) return ReactDOM.createPortal(chatContent, novaRoot);
    }
    return chatContent;
};

export default Chat;